<template>
  <div>
    <v-snackbar v-model="showsnack" :color="level"
    :multi-line="isBad" :timeout="isBad ? 15000 : 5000">
      <v-icon small class="pr-3 hidden-xs-only" dark v-if="isBad">warning</v-icon>
      <v-icon small class="pr-3 hidden-xs-only" dark v-else>info</v-icon>
      &nbsp;
      <span v-html="msg" class="vsnacktext"></span>
      <v-btn dark icon text @click="showsnack = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'snackbars',
  data: () => ({
    showsnack: false
  }),
  computed: {
    snack () {
      return this.$store.state.snack
    },
    level () {
      if (!this.snack) return
      return this.snack.level
    },
    msg () {
      if (!this.snack) return
      return this.snack.msg
    },
    snackid () {
      if (!this.snack) return
      return this.snack.snackid
    },
    isBad () {
      if (!this.level) return false
      return ['error', 'warn', 'fatal'].includes(this.level)
    }
  },
  watch: {
    snackid (val) {
      if (val) this.showsnack = true
    }
  }
}
</script>

<style lang="css">
.vsnacktext {
  font-weight: 400;
  font-size: 15px;
}
</style>
